// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer__outer-container {
  background-color: #0D1F4B;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.scss"],"names":[],"mappings":"AAEA;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAIE;EACE,yBAAA;EACA,kBAAA;AAFJ","sourcesContent":["@import 'src/styles/variables';\n\n.footer {\n  //height: 88px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &__outer-container {\n    background-color: #0D1F4B;\n    position: relative;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
